/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} The_CollectionInputs */

const en_the_collection = /** @type {(inputs: The_CollectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Collection`)
};

const es_the_collection = /** @type {(inputs: The_CollectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La Colección`)
};

const fr_the_collection = /** @type {(inputs: The_CollectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La Collection`)
};

const de_the_collection = /** @type {(inputs: The_CollectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Kollektion`)
};

const ja_the_collection = /** @type {(inputs: The_CollectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コレクション`)
};

const zh_the_collection = /** @type {(inputs: The_CollectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`精品合集`)
};

const ar_the_collection = /** @type {(inputs: The_CollectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المجموعة`)
};

const id_the_collection = /** @type {(inputs: The_CollectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koleksi`)
};

const it_the_collection = /** @type {(inputs: The_CollectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La Collezione`)
};

const ru_the_collection = /** @type {(inputs: The_CollectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Коллекция`)
};

const pt_the_collection = /** @type {(inputs: The_CollectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A Coleção`)
};

const ko_the_collection = /** @type {(inputs: The_CollectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`컬렉션`)
};

/**
* | output |
* | --- |
* | "The Collection" |
*
* @param {The_CollectionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const the_collection = /** @type {((inputs?: The_CollectionInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<The_CollectionInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_the_collection(inputs)
	if (locale === "es") return es_the_collection(inputs)
	if (locale === "fr") return fr_the_collection(inputs)
	if (locale === "de") return de_the_collection(inputs)
	if (locale === "ja") return ja_the_collection(inputs)
	if (locale === "zh") return zh_the_collection(inputs)
	if (locale === "ar") return ar_the_collection(inputs)
	if (locale === "id") return id_the_collection(inputs)
	if (locale === "it") return it_the_collection(inputs)
	if (locale === "ru") return ru_the_collection(inputs)
	if (locale === "pt") return pt_the_collection(inputs)
	return ko_the_collection(inputs)
});